export async function toArrayFromAsync<T>(
  asyncGenerator: AsyncGenerator<T>,
): Promise<T[]> {
  const items: T[] = [];
  for await (const item of asyncGenerator) {
    items.push(item);
  }
  return items;
}
